import type { LucideIcon } from "lucide-react";
import {
	Bandage,
	Bitcoin,
	Briefcase,
	Building2,
	Car,
	CreditCard,
	Gem,
	HeartPulse,
	House,
	Landmark,
	PiggyBank,
	Plane,
	Sofa,
	TrendingUp,
	Umbrella,
	Zap,
} from "lucide-react";
import type { ObjPathProxy } from "ts-object-path";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

export type PortfolioAddItemSectionId =
	| "insurance"
	| "savings"
	| "loans"
	| "property"
	| "other";

export type PortfolioAddItemId =
	| "lifeInsurance"
	| "propertyInsurance"
	| "householdInsurance"
	| "liabilityInsurance"
	| "vehicleInsurance"
	| "travelInsurance"
	| "businessInsurance"
	| "accidentInsurance"
	| "investment"
	| "pension"
	| "buildingSavings"
	| "bankProduct"
	| "crypto"
	| "commodity"
	| "mortgage"
	| "consumerLoan"
	| "businessLoan"
	| "leasing"
	| "auto"
	| "propertyItem"
	| "art"
	| "service";

export type PortfolioItemColor =
	| "pink"
	| "orange"
	| "blue"
	| "sky"
	| "violet"
	| "green"
	| "amber"
	| "teal"
	| "indigo"
	| "yellow"
	| "red"
	| "neutral";

type LabelProxy = ObjPathProxy<unknown, string>;

export type PortfolioAddItemConfig = {
	id: PortfolioAddItemId;
	labelKey: LabelProxy;
	icon: LucideIcon;
	color: PortfolioItemColor;
};

type PortfolioAddItemSection = {
	id: PortfolioAddItemSectionId;
	labelKey: LabelProxy;
	items: PortfolioAddItemConfig[];
};

export const PORTFOLIO_ADD_ITEM_SECTIONS: PortfolioAddItemSection[] = [
	{
		id: "insurance",
		labelKey: Resources.Portfolio.AddItem.Sections.insurance,
		items: [
			{
				id: "lifeInsurance",
				labelKey: Resources.Portfolio.AddItem.Items.lifeInsurance,
				icon: HeartPulse,
				color: "pink",
			},
			{
				id: "propertyInsurance",
				labelKey: Resources.Portfolio.AddItem.Items.propertyInsurance,
				icon: House,
				color: "orange",
			},
			{
				id: "householdInsurance",
				labelKey: Resources.Portfolio.AddItem.Items.householdInsurance,
				icon: Sofa,
				color: "amber",
			},
			{
				id: "liabilityInsurance",
				labelKey: Resources.Portfolio.AddItem.Items.liabilityInsurance,
				icon: Umbrella,
				color: "teal",
			},
			{
				id: "vehicleInsurance",
				labelKey: Resources.Portfolio.AddItem.Items.vehicleInsurance,
				icon: Car,
				color: "blue",
			},
			{
				id: "travelInsurance",
				labelKey: Resources.Portfolio.AddItem.Items.travelInsurance,
				icon: Plane,
				color: "sky",
			},
			{
				id: "businessInsurance",
				labelKey: Resources.Portfolio.AddItem.Items.businessInsurance,
				icon: Briefcase,
				color: "violet",
			},
			{
				id: "accidentInsurance",
				labelKey: Resources.Portfolio.AddItem.Items.accidentInsurance,
				icon: Bandage,
				color: "red",
			},
		],
	},
	{
		id: "savings",
		labelKey: Resources.Portfolio.AddItem.Sections.savings,
		items: [
			{
				id: "investment",
				labelKey: Resources.Portfolio.AddItem.Items.investment,
				icon: TrendingUp,
				color: "green",
			},
			{
				id: "pension",
				labelKey: Resources.Portfolio.AddItem.Items.pension,
				icon: PiggyBank,
				color: "amber",
			},
			{
				id: "buildingSavings",
				labelKey: Resources.Portfolio.AddItem.Items.buildingSavings,
				icon: Building2,
				color: "teal",
			},
			{
				id: "bankProduct",
				labelKey: Resources.Portfolio.AddItem.Items.bankProduct,
				icon: Landmark,
				color: "indigo",
			},
			{
				id: "crypto",
				labelKey: Resources.Portfolio.AddItem.Items.crypto,
				icon: Bitcoin,
				color: "yellow",
			},
			{
				id: "commodity",
				labelKey: Resources.Portfolio.AddItem.Items.commodity,
				icon: Gem,
				color: "yellow",
			},
		],
	},
	{
		id: "loans",
		labelKey: Resources.Portfolio.AddItem.Sections.loans,
		items: [
			{
				id: "mortgage",
				labelKey: Resources.Portfolio.AddItem.Items.mortgage,
				icon: House,
				color: "orange",
			},
			{
				id: "consumerLoan",
				labelKey: Resources.Portfolio.AddItem.Items.consumerLoan,
				icon: CreditCard,
				color: "red",
			},
			{
				id: "leasing",
				labelKey: Resources.Portfolio.AddItem.Items.leasing,
				icon: Car,
				color: "teal",
			},
			{
				id: "businessLoan",
				labelKey: Resources.Portfolio.AddItem.Items.businessLoan,
				icon: Building2,
				color: "blue",
			},
		],
	},
	{
		id: "property",
		labelKey: Resources.Portfolio.AddItem.Sections.property,
		items: [
			{
				id: "auto",
				labelKey: Resources.Portfolio.AddItem.Items.auto,
				icon: Car,
				color: "neutral",
			},
			{
				id: "propertyItem",
				labelKey: Resources.Portfolio.AddItem.Items.propertyItem,
				icon: House,
				color: "neutral",
			},
			{
				id: "art",
				labelKey: Resources.Portfolio.AddItem.Items.art,
				icon: Gem,
				color: "neutral",
			},
		],
	},
	{
		id: "other",
		labelKey: Resources.Portfolio.AddItem.Sections.other,
		items: [
			{
				id: "service",
				labelKey: Resources.Portfolio.AddItem.Items.service,
				icon: Zap,
				color: "neutral",
			},
		],
	},
];
